import { ERROR_MESSAGE_REQUIRED, PRONOUNS } from '../../config'
import FormSlide from '../FormSlide'

export default function AboutYouSlide (props) {
  return (
    <FormSlide
      title="Let's learn more about you"
      stageName='Learning more about you'
      description='Aragon is a welcoming & inclusive community. We want everyone to feel comfortable expressing all aspects of their identities. Tell us more about what makes you uniquely you!'
      formData={[
        {
          text: 'What is your name?',
          label: 'name',
          placeholder: '',
          type: 'text-box',
          errorHandling: { required: ERROR_MESSAGE_REQUIRED }
        },
        {
          text: 'How would you introduce yourself?',
          label: 'introduction',
          placeholder: '',
          type: 'big-text-box',
          errorHandling: { required: ERROR_MESSAGE_REQUIRED }
        },
        {
          text: 'Which pronouns do you best identify with? (optional)',
          label: 'pronouns',
          placeholder: '',
          type: 'select',
          options: PRONOUNS
        },
        {
          text: 'Where in the world are you from?',
          label: 'location',
          placeholder: '',
          type: 'select-location',
          errorHandling: { required: ERROR_MESSAGE_REQUIRED }
        },
        {
          text: 'What languages are you fluent in?',
          label: 'languages',
          placeholder: '',
          type: 'text-box',
          errorHandling: { required: ERROR_MESSAGE_REQUIRED }
        }
      ]}
      {...props}
    />
  )
}
